import {
  FaqSection as UIFaqSection,
  FaqSectionProps,
  AccordionItem,
  SimpleRichTextProps,
  SectionBackgroundColorType,
  SectionTopPaddingSizeType,
  SectionBottomPaddingSizeType,
} from "@repo/ui-parkmobile";
import {
  storyblokEditable,
  SbBlokData,
  StoryblokServerRichText,
  StoryblokRichTextNode,
} from "@storyblok/react/rsc";
import type { FaqSection } from "@/generated/sb";
import React, { ReactElement } from "react";
import { sectionTitleResolver } from "@/lib/storyblok/adaptors";
import { getSectionName } from "@/utils/analytics";
import { trackFAQClick } from "@/utils/trackingScripts";

export function FaqSection({ blok }: { blok: FaqSection }) {
  const head = blok.text
    ? sectionTitleResolver(blok.text) || undefined
    : undefined;

  const sectionName = getSectionName(blok.text, "FAQ Section");

  const questions: AccordionItem[] =
    blok.questions?.map((question) => {
      const bgColor =
        question.backgroundColor === "" || !question.backgroundColor
          ? undefined
          : (question.backgroundColor as AccordionItem["backgroundColor"]);

      return {
        title: question.title || "",
        text:
          question.text?.map((textBlok) => ({
            children: (
              <StoryblokServerRichText
                doc={textBlok.content as StoryblokRichTextNode<ReactElement>}
              />
            ),
            size: (textBlok.size || "medium") as NonNullable<
              SimpleRichTextProps["size"]
            >,
            fontColor: (textBlok.fontColor || "default") as NonNullable<
              SimpleRichTextProps["fontColor"]
            >,
          })) || [],
        backgroundColor: bgColor,
      };
    }) || [];

  const handleItemToggle = (index: number, title: string, isOpen: boolean) => {
    if (isOpen) {
      trackFAQClick({
        section: sectionName,
        innerText: title,
        config: "accordionItem",
      });
    }
  };

  const faqProps: FaqSectionProps = {
    head,
    questions,
    backgroundColor: blok.backgroundColor as SectionBackgroundColorType,
    topPadding: blok.topPadding as SectionTopPaddingSizeType,
    bottomPadding: blok.bottomPadding as SectionBottomPaddingSizeType,
    onItemToggle: handleItemToggle,
  };

  return (
    <UIFaqSection
      {...faqProps}
      {...storyblokEditable(blok as SbBlokData)}
      id={blok.anchor}
    />
  );
}
